import { configureStore } from "@reduxjs/toolkit"
import { TypedUseSelectorHook, useSelector } from "react-redux"
import eventSlice from "./eventSlice"
import gallerySlice from "./gallerySlice"
import utilSlice from "./utilSlice"
import themeSlice from "./themeSlice"
import uploadSlice from "./uploadSlice"

export const store = configureStore({
  reducer: {
    event: eventSlice,
    gallery: gallerySlice,
    util: utilSlice,
    theme: themeSlice,
    upload: uploadSlice
  },
})

export type MyDispatch = typeof store.dispatch

export const MySelector: TypedUseSelectorHook<
  ReturnType<typeof store.getState>
> = useSelector
